/* eslint-disable no-unused-vars */
import JobService from "@/services/job";

import { SET_JOBS, SET_TASKS, SET_SELECTED_JOBS } from "./types";

export async function fetchJobs({commit}, force) {
  const {data} = await JobService.list({force});
  const jobs = data.data.jobs;
  commit(SET_JOBS, jobs);
  return data;
}

export async function createJob({commit}, params) {
  const {data} = await JobService.create(params);
  return data;
}

export async function updateJob({commit}, params) {
  const {data} = await JobService.update(params);
  return data;
}

export async function deleteJobs({commit}, ids) {
  const {data} = await JobService.delete(ids);
  return data;
}

export async function startJob({commit}, id) {
  const {data} = await JobService.start(id);
  return data;
}

export async function stopJob({commit}, id) {
  const {data} = await JobService.stop(id);
  return data;
}

export async function restartJob({commit}, id) {
  const {data} = await JobService.restart(id);
  return data;
}

export async function getThreads({commit}, id) {
  const {data} = await JobService.getThreads(id);
  return data.data.threads;
}

export async function clearJob({commit}, id) {
  const {data} = await JobService.clear(id);
  return data;
}

export async function getLogs({commit}, id, lines) {
  const {data} = await JobService.getLogs(id, lines);
  return data.data.logs;
}